import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["page", "limit"],
  _excluded2 = ["data", "isLoading"],
  _excluded3 = ["id"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { concat, reduce } from 'lodash';
import { createCrud, createQueryKey, useAxiosClient, useInfiniteQuery, useMutation, useQuery } from '@lumahealthhq/ui-model';
var basePath = 'appointments';
var crud = createCrud('appointments');
export var useAppointmentUpdateOne = crud.makeUpdateOne();
var dirtyAppointmentAction = 'dirty';
var mutateOptions = {
  dirty: {
    url: 'v2/appointments',
    method: 'post'
  },
  "default": {
    url: 'appointments',
    method: 'put'
  }
};
export function useUpdateAppointment() {
  var axiosClient = useAxiosClient();
  var mutationFn = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var id, action, isDirtyAppointmentAction, methodOption, _yield$axiosClient$me, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            id = _ref.id, action = _ref.action;
            isDirtyAppointmentAction = action === dirtyAppointmentAction;
            methodOption = isDirtyAppointmentAction ? mutateOptions.dirty : mutateOptions["default"];
            _context.next = 5;
            return axiosClient[methodOption.method]("".concat(methodOption.url, "/").concat(id, "/").concat(action));
          case 5:
            _yield$axiosClient$me = _context.sent;
            data = _yield$axiosClient$me.data;
            return _context.abrupt("return", data);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function mutationFn(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return useMutation(['appointments', 'updateAppointment', 'scheduleAppointments', 'pages/patientPage/appointments'], mutationFn);
}
export function useUpdateAppointmentAction2() {
  var axiosClient = useAxiosClient();
  var mutationFn = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
      var id, action, _yield$axiosClient$pu, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            id = _ref3.id, action = _ref3.action;
            _context2.next = 3;
            return axiosClient.put("/appointments/".concat(id, "/").concat(action));
          case 3:
            _yield$axiosClient$pu = _context2.sent;
            data = _yield$axiosClient$pu.data;
            return _context2.abrupt("return", data);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function mutationFn(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  return useMutation(['updateAppointment', 'scheduleProviders', 'scheduleAppointments'], mutationFn);
}
export function useUpdateAppointment2() {
  var axiosClient = useAxiosClient();
  var mutationFn = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
      var id, updates, _yield$axiosClient$pu2, data;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            id = _ref5.id, updates = _ref5.updates;
            _context3.next = 3;
            return axiosClient.put("/appointments/".concat(id), updates);
          case 3:
            _yield$axiosClient$pu2 = _context3.sent;
            data = _yield$axiosClient$pu2.data;
            return _context3.abrupt("return", data);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function mutationFn(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();
  return useMutation(['updateAppointment', 'scheduleProviders', 'scheduleAppointments'], mutationFn);
}
export function useAppointmentsPaginationV2(params, queryOptions) {
  var axiosService = useAxiosClient();
  var key = ['appointments', params];
  var queryFn = React.useCallback(/*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
      var _response$headers, _response$data;
      var page, _ref7$limit, limit, restParams, normalizedPage, firstData, lastData, headers, response, contentRangeArray, totalSize;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            page = _ref7.page, _ref7$limit = _ref7.limit, limit = _ref7$limit === void 0 ? 3 : _ref7$limit, restParams = _objectWithoutProperties(_ref7, _excluded);
            normalizedPage = +page - 1;
            firstData = +normalizedPage * +limit;
            lastData = +normalizedPage * +limit + (+limit - 1);
            headers = {
              'content-range': "".concat(firstData, "-").concat(lastData)
            };
            _context4.next = 7;
            return axiosService.get('v2/appointments', {
              params: _extends({}, restParams, {
                page: page
              }),
              headers: headers
            });
          case 7:
            response = _context4.sent;
            contentRangeArray = (((_response$headers = response.headers) == null ? void 0 : _response$headers['content-range']) || '').split('/');
            totalSize = +contentRangeArray[contentRangeArray.length - 1];
            return _context4.abrupt("return", {
              data: (_response$data = response.data) != null ? _response$data : [],
              totalSize: totalSize
            });
          case 11:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x4) {
      return _ref8.apply(this, arguments);
    };
  }(), [axiosService]);
  var _params$limit = params.limit,
    limit = _params$limit === void 0 ? 3 : _params$limit;
  var _useInfiniteQuery = useInfiniteQuery(key, function (_ref9) {
      var _ref9$pageParam = _ref9.pageParam,
        pageParam = _ref9$pageParam === void 0 ? 1 : _ref9$pageParam;
      return queryFn(_extends({}, params, {
        page: pageParam
      }));
    }, _extends({
      staleTime: 2,
      getNextPageParam: function getNextPageParam(lastPage, allPages) {
        var totalItems = (allPages.length - 1) * limit + lastPage.data.response.length;
        if (totalItems < lastPage.totalSize) {
          return lastPage.data.page + 1;
        }
        return undefined;
      }
    }, queryOptions || {})),
    data = _useInfiniteQuery.data,
    isLoading = _useInfiniteQuery.isLoading,
    queryResult = _objectWithoutProperties(_useInfiniteQuery, _excluded2);
  var allItems = React.useMemo(function () {
    return reduce(data == null ? void 0 : data.pages, function (result, page) {
      return concat(result, page.data.response);
    }, []);
  }, [data]);
  return _extends({
    allItems: allItems,
    data: data,
    isLoading: isLoading
  }, queryResult);
}
export function useMessagePatient() {
  var axiosClient = useAxiosClient();
  var fetchFn = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref10) {
      var appointment, patient, _yield$axiosClient$po, data;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            appointment = _ref10.appointment, patient = _ref10.patient;
            _context5.next = 3;
            return axiosClient.post("v2/appointments/message/copay", {
              appointment: appointment,
              patient: patient
            });
          case 3:
            _yield$axiosClient$po = _context5.sent;
            data = _yield$axiosClient$po.data;
            return _context5.abrupt("return", data);
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function fetchFn(_x5) {
      return _ref11.apply(this, arguments);
    };
  }();
  var mutationResult = useMutation(['appointments', 'copay'], fetchFn);
  return mutationResult;
}
export function useAppointmentByOfferId(_ref12, options) {
  var id = _ref12.id,
    params = _objectWithoutProperties(_ref12, _excluded3);
  var variant = '{basePath}/getByOfferId/{id}';
  var axiosClient = useAxiosClient();
  function queryFn() {
    return _queryFn.apply(this, arguments);
  }
  function _queryFn() {
    _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var url, _yield$axiosClient$ge, data;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            url = variant.replace('{basePath}', basePath).replace('{id}', id);
            _context6.next = 3;
            return axiosClient.get(url, {
              params: params
            });
          case 3:
            _yield$axiosClient$ge = _context6.sent;
            data = _yield$axiosClient$ge.data;
            return _context6.abrupt("return", data);
          case 6:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _queryFn.apply(this, arguments);
  }
  var queryKey = createQueryKey(basePath, variant, params);
  var queryResult = useQuery(queryKey, queryFn, options);
  return queryResult;
}
export function useAppointmentConfirmByOfferId(options) {
  var axiosClient = useAxiosClient();
  function mutationFn(_x6) {
    return _mutationFn.apply(this, arguments);
  }
  function _mutationFn() {
    _mutationFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref13) {
      var id, _yield$axiosClient$pu3, data;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            id = _ref13.id;
            _context7.next = 3;
            return axiosClient.put("".concat(basePath, "/confirmByOfferId/").concat(id));
          case 3:
            _yield$axiosClient$pu3 = _context7.sent;
            data = _yield$axiosClient$pu3.data;
            return _context7.abrupt("return", data);
          case 6:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _mutationFn.apply(this, arguments);
  }
  return useMutation([basePath], mutationFn, options);
}
export function useAppointmentCancelByOfferId(options) {
  var axiosClient = useAxiosClient();
  function mutationFn(_x7) {
    return _mutationFn2.apply(this, arguments);
  }
  function _mutationFn2() {
    _mutationFn2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref14) {
      var id, _yield$axiosClient$pu4, data;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            id = _ref14.id;
            _context8.next = 3;
            return axiosClient.put("".concat(basePath, "/cancelByOfferId/").concat(id));
          case 3:
            _yield$axiosClient$pu4 = _context8.sent;
            data = _yield$axiosClient$pu4.data;
            return _context8.abrupt("return", data);
          case 6:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return _mutationFn2.apply(this, arguments);
  }
  return useMutation([basePath], mutationFn, options);
}
export function useAppointmentUpdateOneArrived(options) {
  var axiosClient = useAxiosClient();
  function mutationFn(_x8) {
    return _mutationFn3.apply(this, arguments);
  }
  function _mutationFn3() {
    _mutationFn3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref15) {
      var id, _yield$axiosClient$po2, data;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            id = _ref15.id;
            _context9.next = 3;
            return axiosClient.post('/waitingroomspatients/join', {
              appointment: id
            });
          case 3:
            _yield$axiosClient$po2 = _context9.sent;
            data = _yield$axiosClient$po2.data;
            return _context9.abrupt("return", data);
          case 6:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return _mutationFn3.apply(this, arguments);
  }
  return useMutation([basePath], mutationFn, options);
}

/**
 * Hook to fetch an appointment based on a method call (e.g., a button click or another event)
 *
 * @example
 * const { fetch, isLoading, data } = useFetchAppointmentById();
 *
 * // In a click handler or useEffect
 * const handleFetchAppointment = () => {
 *   fetch({ id: 'appointment-123' });
 * };
 *
 * // Or using the async version
 * const fetchAppointment = async () => {
 *   const appointment = await fetchAsync({ id: 'appointment-123' });
 *   console.log(appointment);
 * };
 */
export function useFetchAppointmentById() {
  var axiosClient = useAxiosClient();
  var fetchFn = /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref16) {
      var id, _yield$axiosClient$ge2, data;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            id = _ref16.id;
            _context10.next = 3;
            return axiosClient.get("v2/appointments/".concat(id));
          case 3:
            _yield$axiosClient$ge2 = _context10.sent;
            data = _yield$axiosClient$ge2.data;
            return _context10.abrupt("return", data);
          case 6:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function fetchFn(_x9) {
      return _ref17.apply(this, arguments);
    };
  }();
  var mutationResult = useMutation([], fetchFn);
  return _extends({}, mutationResult, {
    fetch: mutationResult.mutate,
    fetchAsync: mutationResult.mutateAsync
  });
}
export function useAppointmentsSyncByDate() {
  var axiosClient = useAxiosClient();
  var mutateFn = React.useCallback(/*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(date) {
      var _yield$axiosClient$po3, data;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return axiosClient.post("v2/".concat(basePath, "/ehrSync"), {
              date: date
            });
          case 2:
            _yield$axiosClient$po3 = _context11.sent;
            data = _yield$axiosClient$po3.data;
            return _context11.abrupt("return", data);
          case 5:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return function (_x10) {
      return _ref18.apply(this, arguments);
    };
  }(), [axiosClient]);
  return useMutation([basePath], mutateFn);
}